import { shimmer, toBase64 } from "@repo/lib/utils";
import { getImageProps } from "next/image";
function ResponsiveBannerImage({
  className,
  desktopSrc,
  mobileSrc,
  desktopWidth,
  desktopHeight,
  mobileWidth,
  mobileHeight,
  alt,
  priority = true,
  breakpoint = 640
}) {
  const sizes = `(max-width: ${breakpoint}px) 100vw, 50vw`;
  const common = {
    alt,
    priority,
    sizes,
    quality: 100,
    style: {
      objectFit: "cover",
      objectPosition: "center"
    }
  };
  const {
    srcSet: desktop
  } = getImageProps({
    ...common,
    src: desktopSrc,
    placeholder: `data:image/svg+xml;base64,${toBase64(shimmer(desktopWidth, desktopHeight))}`,
    width: desktopWidth,
    height: desktopHeight
  })?.props;
  const {
    srcSet: mobile,
    ...rest
  } = getImageProps({
    ...common,
    src: mobileSrc,
    placeholder: `data:image/svg+xml;base64,${toBase64(shimmer(mobileWidth, mobileHeight))}`,
    width: mobileWidth,
    height: mobileHeight
  })?.props;
  return <picture data-sentry-element="picture" data-sentry-component="ResponsiveBannerImage" data-sentry-source-file="ResponsiveBannerImage.jsx">
      {/* Mobile */}
      <source media={`(max-width: ${breakpoint - 1}px)`} srcSet={mobile} width={mobileWidth} height={mobileHeight} sizes={sizes} />

      {/* Desktop */}
      <source media={`(min-width: ${breakpoint}px)`} srcSet={desktop} width={desktopWidth} height={desktopHeight} sizes={sizes} />

      <img alt={alt} {...rest} decoding="async" fetchPriority="high" className={className} loading="eager" />
    </picture>;
}
export default ResponsiveBannerImage;